import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../shared/auth/useAuth.js';
import { useTranslation } from '../../shared/i18n/useLanguage.js';
import { AuthForm } from './AuthForm.js';

export function LoginPage(): ReactElement {
  const { signIn } = useAuth();
  const t = useTranslation();

  return (
    <AuthForm
      title={t.auth.signInTitle}
      submitLabel={t.auth.signInSubmit}
      onSubmit={signIn}
      footer={
        <>
          {t.auth.noAccountYet}
          <Link to="/register">{t.auth.createOne}</Link>.
        </>
      }
    />
  );
}
